import { FC, useState, useRef, MouseEvent, KeyboardEvent, useEffect } from 'react';
import { Grid, IconButton, Typography, Divider, MenuItem, MenuList, Paper, Grow, Popper } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useStore } from 'hooks/useRootStore';
import { useMutation } from 'react-query';
import { useStyles } from './styles';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Profile from './../../../assets/icons/MenuItems/profile.svg';
import Logout from './../../../assets/icons/MenuItems/logout.svg';
import sampleImg from '../../../assets/sample.svg';

import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

import Notification from '../Notification';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
const ProfileMenu: FC = observer(() => {
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const {
    userStore: { user, logout },
    notificationStore: { openNotification },
    // upgradeLicenseStore: { getLicenseInfo, submitUpgradeRequest },
  } = useStore();

  const [imgSrc, setImgSrc] = useState<string>();
  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);

  // const getLicenseInfoReq = useMutation('getLicenseInfoReq', getLicenseInfo, {});
  const logoutRequest = useMutation(() => logout(), {
    mutationKey: 'logoutRequest',

    onSuccess: () => {
      const redirectUrl = endUserConfigSettings?.redirectLoginUrl;
      console.log('Redirect URL:', redirectUrl);
      if (redirectUrl) {
        window.location.replace(redirectUrl);
      } else {
        window.location.replace('/login');
      }
    },
    onError: (error) => {
      console.error('Logout error:', error);
      openNotification('error', 'Something went wrong');
    },
  });
  // const upgradeRequestMutation = useMutation((message: string) => submitUpgradeRequest(message), {
  //   onSuccess: (response: any) => {
  //     const successMessage = response?.data?.message || 'Upgrade request submitted successfully';
  //     openNotification('success', successMessage);
  //     setUpgradeDialogOpen(false);
  //     setUpgradeRequest('');
  //   },
  //   onError: (error: any) => openNotification('error', error.message || 'Failed to submit upgrade request'),
  // });

  const handleToggle = () => setOpen((prev) => !prev);

  const handleClose = (event: MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) return;
    setOpen(false);
  };

  const handleLogout = (event: MouseEvent<EventTarget>) => {
    logoutRequest.mutate();
    handleClose(event);
  };

  const handleProfile = () => history.push(handleCompanyUrl('/admin/profile'));
  const handlePassword = () => history.push(handleCompanyUrl('/admin/change-password'));
  const handleUserEditRequest = () => history.push(handleCompanyUrl('/admin/users-edit-request'));

  function handleListKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = useRef(open);
  useEffect(() => {
    prevOpen.current = open;
    setImgSrc(user?.profileUrl ? user.profileUrl : sampleImg);
  }, [open, user]);

  return (
    <div className={classes.root}>
      <Grid className={classes.profileContainer}>
        {/* {user?.permission !== 'EndUser' && lisenceInfo?.trial === 1 && (
          <Button
            disabled={lisenceInfo?.paidStatus === 2}
            className={classes.applyButton}
            onClick={() => setUpgradeDialogOpen(true)}
          >
            {lisenceInfo?.paidStatus !== 2 ? (
              'Upgrade'
            ) : (
              <>
                <CircularProgress className={classes.preloader} size={18} />
                Upgrade In Progress...
              </>
            )}
          </Button>
        )} */}
        {/* Notification */}
        {user &&
          (user.permission === 'ClientAdmin' || user.permission === 'SystemAdmin' || user.permission === 'Manager') && (
            <Notification link={handleCompanyUrl('/admin/users-edit-request')} />
          )}

        {/* Only Role (Email removed from here) */}
        <Typography className={classes.profileIconLabel}>
          {!isMobile && (
            <>
              <p className={classes.profileName}>{user?.email || ''}</p>
              <div className={classes.profilRole}>
                {user?.permission === 'ClientAdmin' ? 'Administrator' : user?.permission}
              </div>
            </>
          )}
        </Typography>

        {/* Avatar */}
        <IconButton ref={anchorRef} onClick={handleToggle}>
          <img className={classes.profileIcon} src={imgSrc} alt='profile' />
        </IconButton>

        {/* Upgrade Button */}
      </Grid>

      {/* Dropdown */}
      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal placement='bottom'>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper className={classes.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList onKeyDown={handleListKeyDown} autoFocusItem={open}>
                  {/* ✅ EMAIL ONLY ON MOBILE */}
                  {isMobile && (
                    <>
                      <MenuItem disabled>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span style={{ fontSize: 13, fontWeight: 500 }}>{user?.email}</span>
                          <span style={{ fontSize: 11, color: 'gray' }}>
                            {user?.permission === 'ClientAdmin' ? 'Administrator' : user?.permission}
                          </span>
                        </div>
                      </MenuItem>

                      <Divider />
                    </>
                  )}

                  {/* PROFILE */}
                  <MenuItem onClick={handleProfile} className={classes.IconContent}>
                    <span className={classes.MyProfileIcon}>
                      <img src={Profile} alt='' className={classes.imageStyling} />
                    </span>
                    <span>My Profile</span>
                  </MenuItem>

                  {/* END USER REQUESTS */}
                  {user?.permission !== 'EndUser' && (
                    <MenuItem onClick={handleUserEditRequest} className={classes.IconContent}>
                      <span className={classes.MyProfileIcon}>
                        <RecordVoiceOverIcon sx={{ height: '20px' }} color='inherit' />
                      </span>
                      <span>End-User Requests</span>
                    </MenuItem>
                  )}

                  {/* CHANGE PASSWORD */}
                  <MenuItem onClick={handlePassword} className={classes.IconContent}>
                    <span className={classes.MyProfileIcon}>
                      <SettingsSuggestIcon />
                    </span>
                    <span>Change Password</span>
                  </MenuItem>

                  {/* LOGOUT */}
                  <MenuItem onClick={handleLogout} className={classes.IconContent}>
                    <span className={classes.MyProfileIcon}>
                      <img src={Logout} alt='' className={classes.imageStyling} />
                    </span>
                    <span>Logout</span>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      {/* 
      <Dialog open={upgradeDialogOpen} onClose={() => setUpgradeDialogOpen(false)} maxWidth='sm' fullWidth>
        <DialogTitle>Upgrade Request</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            rows={4}
            fullWidth
            variant='outlined'
            placeholder='Please describe what you would like to upgrade...'
            value={upgradeRequest}
            onChange={(e) => setUpgradeRequest(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUpgradeDialogOpen(false)}>Cancel</Button>
          <Button
            variant='contained'
            color='primary'
            disabled={!upgradeRequest.trim() || upgradeRequestMutation.isLoading}
            onClick={() => upgradeRequestMutation.mutate(upgradeRequest)}
          >
            {upgradeRequestMutation.isLoading ? 'Submitting...' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog> */}
    </div>
  );
});

export default ProfileMenu;
